export default "__VITE_ASSET__DXAJO5N2__"